const textElements = document.querySelectorAll(".text-wrapper")

let animationStarted = false;

Array.from(textElements).forEach((elem) => {
    elem.addEventListener("mouseenter", () => {
        if (animationStarted) {
            return;
        }
        animationStarted = true
        elem.classList.add("touched")
        setTimeout(() => animationStarted = false, 400)
    })
    elem.addEventListener("mouseleave", () => {
        if (!animationStarted) {
            elem.classList.remove("touched")
        }
    })
})


let observer = new MutationObserver(function(mutations) {
    for (let mutation of mutations) {
        if (mutation.type === 'attributes') {
            if (mutation.target.className.includes('touched')) {

            }
        }
    }
});

Array.from(textElements).forEach((elem) => {
    observer.observe(elem, { attributes: true });
})


